import type { FaceLivenessDetectionError } from "./FaceLivenessDetectionError.js"

/**
 * @description
 *	The error shown when the signed query parameters of the session are
 *	missing or invalid, before anything of the verification starts.
 *
 * @remarks
 *	The name of the inner error is the one that the Amplify widget reports for
 *	an unusable session, so the human being reads the very same message no
 *	matter where the session was rejected.
 */
const InvalidSessionFaceLivenessDetectionError: FaceLivenessDetectionError = {
	error: {
		message: "The signed query parameters of the session are missing or invalid.",
		name: "ValidationException"
	},
	state: "UNKNOWN_ERROR"
}

export default InvalidSessionFaceLivenessDetectionError
